import { useState, useCallback, useEffect } from "react";
import { useForm, FormProvider } from "react-hook-form";
import { RHFInput } from "../Inputs/RHFInput";
import checkIcon from "../Toast/Image/check.svg";
import errorIcon from "../Toast/Image/error.svg";
import Toast from "../Toast/Toast";
import SetaVoltarImg from "../../assets/images/SetaVoltar.png";

import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Button,
    IconButton,
    Box,
    Typography,
  } from "@mui/material";
import DeleteIcon from "../../assets/images/icons/Excluir_Compromisso.svg";
import CancelIcon from "../../assets/images/icons/Cancelar_Compromisso.svg";
import CompleteIcon from "../../assets/images/icons/Concluir_Compromisso.svg";
import FeedbackIcon from "../../assets/images/icons/Feedback_Compromisso.svg";
import ModalFeedback from "../Modais/ModalFeedback";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { readDataStorage } from "../../utils/storage/storage";


import { styled } from "@mui/system";

import {
  DivForm,
  DivContainer,
  RadioInputContainer,
  InputLabel,
} from "../GeradorDePropostas/styles";
import { ButtonDelete, ButtonOK,Title1 } from "./styles";
import api from "../../services/api/index";
import { useAPI } from "../../hooks/contextApis";
import { useProgress } from "../../hooks/progress";
  const {
    NomeRepresentante,
    CpfRepresentante
  } = readDataStorage("login");

export default function NovoCompromisso({ onClose, compromisso }: any) {
  const { dataUser } = useAPI();
  const { setLoad } = useProgress();
  const methods = useForm();
  const { handleSubmit, watch, reset } = methods;

  const [list, setList] = useState<unknown[]>([]);
  const [tipoCompromisso, setTipoCompromisso] = useState("Reunião");
  const [open, setOpen] = useState(false);
  const [modalType, setModalType] = useState("");
  const [modalIsOpenFeedback, setIsOpenFeedback] = useState(false);
  const [historico, setHistorico] = useState<any[]>([]);
  const [expandedStep, setExpandedStep] = useState<number[]>([]);

  const handleOpen = (type:any) => {
    setModalType(type);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setModalType("");
  };


  const getDialogText = () => {
    switch (modalType) {
      case "excluir":
        return (
            <>
              Deseja realmente excluir o compromisso?
              <br />
              A ação não poderá ser desfeita.
            </>
          );
      case "cancelar":
        return (
            <>
              Deseja realmente cancelar o compromisso?
              <br />
              A ação não poderá ser desfeita.
            </>
          );
      case "concluir":
        return (
            <>
              Deseja realmente concluir o compromisso?
              <br />
              A ação não poderá ser desfeita.
            </>
          );
      default:
        return "";
    }
  };

  const showToast = useCallback(
    async (type: string) => {
      const id = Math.floor(Math.random() * 101 + 1);
      let toastProperties = {
        id,
        title: "",
        description: "",
        backgroundColor: "",
        icon: checkIcon,
      };

      switch (type) {
        case "201":
          toastProperties.description = "Compromisso criado com sucesso";
          toastProperties.backgroundColor = "#5cb85c";
          break;
        case "200Concluido":
          toastProperties.description = "Compromisso concluído";
          toastProperties.backgroundColor = "#5cb85c";
          break;
        case "200Cancelado":
          toastProperties.description = "Compromisso cancelado";
          toastProperties.backgroundColor = "#5cb85c";
          break;
        case "200":
          toastProperties.description = "Já existe um compromisso para este horário";
          toastProperties.backgroundColor = "#f0ad4e";
          toastProperties.icon = errorIcon;
          break;
        case "200Editar":
          toastProperties.description = "Compromisso alterado";
          toastProperties.backgroundColor = "#f0ad4e";
          toastProperties.icon = checkIcon;
          break;
          
        case "200Exclude":
            toastProperties.description = "Compromisso excluido";
            toastProperties.backgroundColor = "#f0ad4e";
            toastProperties.icon = errorIcon;
            break;
        case "ErroExclude":
            toastProperties.description = "Falha ao excluir";
            toastProperties.backgroundColor = "#f0ad4e";
            toastProperties.icon = errorIcon;
          break;
        case "400":
          toastProperties.description = "Campos inválidos! Verifique os dados informados.";
          toastProperties.backgroundColor = "#d9534f";
          toastProperties.icon = errorIcon;
          break;
        case "403":
          toastProperties.description = "Acesso não autorizado";
          toastProperties.backgroundColor = "#d9534f";
          toastProperties.icon = errorIcon;
          break;
        case "500":
          toastProperties.description = "Erro interno do servidor. Tente novamente";
          toastProperties.backgroundColor = "#d9534f";
          toastProperties.icon = errorIcon;
          break;
        default:
          return;
      }

      setList((prev) => [...prev, toastProperties]);

      if (type === "201") {
        setTimeout(() => {
          onClose();
        }, 1000);
      }
    },
    [onClose]
  );

  const formatarData = (dataIso: string) => {
    const data = new Date(dataIso);
    return data.toLocaleString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      timeZone: "America/Sao_Paulo",
    });
  };

  useEffect(() => {
    if (compromisso) {
      const dataLocal = new Date(compromisso.dataHoraComp)
      .toISOString()
      .slice(0, 16);
      reset({
        dataHora: dataLocal,
        descricao: compromisso.descricao,
        endereco: compromisso.endereco || "",
        participantes: compromisso.participantes || "",
        detalhes: compromisso.detalhes || "",
        
      });
      setTipoCompromisso(compromisso.tipo || "Reunião");
      const historico = [
        {
          status: "criado",
          descricao: "Compromisso criado",
          dataHora: formatarData(compromisso.dataHoraCriacao),
          texto:'',
          responsavel: NomeRepresentante,
        }
      ];
      
      if (compromisso.feedback && compromisso.feedback.length > 0) {
        compromisso.feedback.forEach((fb:any) => {
          historico.push({
            status: "feedback",
            descricao: `Feedback adicionado`,
            texto: `Feedback: ${fb.descricao}`,
            dataHora: formatarData(fb.dataHoraCriacao),
            responsavel: NomeRepresentante,
          });
        });
      }
      setHistorico(historico);
    }
  }, [compromisso, reset]);


  const handleSalvar = async (data: any) => {
    try {
      setLoad(true);
      api.defaults.headers.common = {
        Authorization: `bearer ${sessionStorage.getItem("@ARP-Energia:token")}`,
      };

      const compromissoData = {
        cpf: CpfRepresentante,
        idCard: dataUser?.idCard || "123456789",
        tipo: tipoCompromisso,
        descricao: data.descricao,
        endereco: data.endereco,
        participantes: data.participantes,
        detalhes: data.detalhes,
        status: "Ativo",
        dataHoraComp: data.dataHora,
      };

      let response;

      if (compromisso?.id) {
        response = await api.put(`/csp/representante/compromissos/alterar/${compromisso.id}`, compromissoData);
      } else {
        response = await api.post(`/csp/representante/compromissos/criar`, compromissoData);
      }

      if (response.status === 201) {
        await showToast("201");
      } else if (response.status === 200) {
        
        if (compromisso?.id) {
          await showToast("200Editar");
          
          setTimeout(() => {
            onClose();
          }, 1000);
        } else {
          response = await api.post(`/csp/representante/compromissos/criar`, compromissoData);
        }
      }
    } catch (error: any) {
      if (error.response) {
        await showToast(error.response.status.toString());
      } else {
        await showToast("500");
      }
    } finally {
      setTimeout(() => {
        setLoad(false);
      }, 1000);
    }
  };

  const StyledCancelButton = styled(Button)({
    border: "1px solid #6C5AF4",
    borderRadius:'8px',
    color: "#6C5AF4",
    backgroundColor: "white",
    textTransform: "none",
    '&:hover': {
      backgroundColor: "#ECE8FD",
    },
  });
  
  const StyledConfirmButton = styled(Button)({
    backgroundColor: "#6C5AF4",
    color: "white",
    borderRadius:'8px',
    textTransform: "none",
    '&:hover': {
      backgroundColor: "#5A47C4",
    },
  });

  const StyledDialog = styled(Dialog)({
    '& .MuiPaper-root': {
      backgroundColor: "#FFFFFF !important",
      borderRadius: "15px",
    }
  });

  const handleExcluir = async () => {

    if (!compromisso?.id) return;
  
    try {
      setLoad(true);
      api.defaults.headers.common = {
        Authorization: `bearer ${sessionStorage.getItem("@ARP-Energia:token")}`,
      };
  
      const response = await api.delete(`/csp/representante/compromissos/excluir/${compromisso?.id}`);
  
      if (response.status === 200) {
        showToast("200Exclude"); 
          setTimeout(() => {
            onClose();
          }, 1000);
      } 
    } catch (error: any) {
      if (error.response) {
        await showToast("ErroExclude");
      } else {
        await showToast("500");
      }
    } finally {
      setLoad(false);
    }
  };

  const closeModal = () => {
    setIsOpenFeedback(false);
  };

  const handleStatusUpdate = async () => {
    if (!compromisso?.id) return;
  
    try {
      setLoad(true);
      api.defaults.headers.common = {
        Authorization: `bearer ${sessionStorage.getItem("@ARP-Energia:token")}`,
      };
  
      let status = "";
      if (modalType === "concluir") {
        status = "Concluído";
      } else if (modalType === "cancelar") {
        status = "Cancelado";
      }
      const data = new Date(compromisso?.dataHoraComp);
      const dataFormatada = data.toISOString().replace('T', ' ').substring(0, 19);
      if (status) {
        const response = await api.put(`/csp/representante/compromissos/alterar/${compromisso?.id}`, {
          
            "tipo": compromisso?.tipo,
            "endereco": compromisso?.endereco,
            "participantes": compromisso?.participantes,
            "status": status,
            "dataHoraComp": dataFormatada, 
        });
        if (response.status === 200) {
          if (modalType === "concluir") {
            showToast("200Concluido"); 
          } else if (modalType === "cancelar") {
            showToast("200Cancelado"); 
          }
          setTimeout(() => {
            onClose(); 
          }, 1000);
        }
      }
    } catch (error: any) {
      if (error.response) {
        await showToast(error.response.status.toString());
      } else {
        await showToast("500");
      }
    } finally {
      setLoad(false);
      setOpen(false); 
    }
  };
  
  const handleConfirm = () => {
    switch (modalType) {
      case "concluir":
      case "cancelar":
        handleStatusUpdate();
        break;
      case "excluir":
        handleExcluir();
        break;
      default:
        setOpen(false);
        setModalType("");
        break;
    }
  };

  return (
    <>
      <ModalFeedback
        isOpen={modalIsOpenFeedback}
        onRequestClose={closeModal}
        id={compromisso?.id}
      />
      <Toast toastList={list} autoDelete={true} />
      <FormProvider {...methods}>
        <DivForm>
        <Box display="flex" justifyContent="space-between" alignItems="center" marginTop="2em" marginBottom="2em">
        <img
            alt=""
            src={SetaVoltarImg}
            onClick={onClose}
            style={{width:'25px', cursor:'pointer'}}
          ></img>
        <Title1>{compromisso ? "Editar compromisso" : "Novo compromisso"} - ID {dataUser?.idCard}</Title1>
        <Box>
        <IconButton onClick={() => setIsOpenFeedback(true)}>
            <img src={FeedbackIcon} alt="Feedback" width={24} height={24} />
          </IconButton>
        <IconButton onClick={() => handleOpen("concluir")}>
            <img src={CompleteIcon} alt="Concluir" width={24} height={24} />
          </IconButton>
          <IconButton onClick={() => handleOpen("cancelar")}>
            <img src={CancelIcon} alt="Cancelar" width={24} height={24} />
          </IconButton>
          <IconButton onClick={() => handleOpen("excluir")}>
            <img src={DeleteIcon} alt="Excluir" width={24} height={24} />
          </IconButton>


        </Box>
      </Box>

          <form onSubmit={handleSubmit(handleSalvar)}>
            <DivContainer>
              <RHFInput
                type="datetime-local"
                name="dataHora"
                placeholder="Data e hora do compromisso"
                label="Data e hora do compromisso"
              />
              <RHFInput
                type="text"
                name="descricao"
                placeholder="Descrição do compromisso"
                label="Descrição do compromisso"
              />
            </DivContainer>
            <RadioInputContainer>
              <InputLabel style={compromisso ? { color: "#A0A0A0", opacity: 0.6, cursor: "not-allowed" } : {}}>
                <input
                  type="radio"
                  name="tipoCompromisso"
                  value="Reunião"
                  checked={tipoCompromisso === "Reunião"}
                  disabled={!!compromisso}
                  onChange={() => setTipoCompromisso("Reunião")}
                />
                Reunião
              </InputLabel>
              <InputLabel style={compromisso ? { color: "#A0A0A0", opacity: 0.6, cursor: "not-allowed" } : {}}>
                <input
                  type="radio"
                  name="tipoCompromisso"
                  value="Visita"
                  checked={tipoCompromisso === "Visita"}
                  disabled={!!compromisso}
                  onChange={() => setTipoCompromisso("Visita")}
                />
                Visita
              </InputLabel>
              <InputLabel style={compromisso ? { color: "#A0A0A0", opacity: 0.6, cursor: "not-allowed" } : {}}>
                <input
                  type="radio"
                  name="tipoCompromisso"
                  value="Contato"
                  checked={tipoCompromisso === "Contato"}
                  disabled={!!compromisso}
                  onChange={() => setTipoCompromisso("Contato")}
                />
                Contato
              </InputLabel>
            </RadioInputContainer>

            <RHFInput
              type="text"
              name="endereco"
              placeholder="Endereço/Link da reunião"
              label="Endereço/Link da reunião"
            />
            <RHFInput
              type="text"
              name="participantes"
              placeholder="Participantes"
              label="Participantes"
            />
            <RHFInput
              type="text"
              name="detalhes"
              placeholder="Detalhes do compromisso"
              label="Detalhes do compromisso"
            />

            <DivContainer style={{ justifyContent: "end" }}>
              <ButtonDelete type="button" onClick={onClose}>
                {compromisso ? "Cancelar" : "Cancelar"}
              </ButtonDelete>
              <ButtonOK type="submit" disabled={!watch("dataHora") || !watch("descricao")}>
                Salvar
              </ButtonOK>
            </DivContainer>
          </form>
          {historico.length === 0 ? (
            <></>
            ) : (
                <Box sx={{ maxWidth: 400, padding: 3, marginBottom: "2em" }}>
                  {historico.map((item:any, index:number) => {
                    const isExpanded = expandedStep.includes(index);

                    return (
                      <Box key={index} sx={{ display: "flex", alignItems: "flex-start", position: "relative" }}>
                        {index !== historico.length - 1 && (
                          <Box
                            sx={{
                              position: "absolute",
                              left: "14px",
                              top: "30px",
                              width: "2px",
                              height: "calc(100% - 32px)",
                              backgroundColor: "#A0A0A0",
                            }}
                          />
                        )}

                        <Box
                          sx={{
                            width: 28,
                            height: 28,
                            borderRadius: "50%",
                            backgroundColor: "#4F46E5",
                            color: "white",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                            zIndex: 1,
                          }}
                          onClick={() =>
                            setExpandedStep((prev) =>
                              prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
                            )
                          }
                        >
                          {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                        </Box>

                        <Box sx={{ marginLeft: "10px", marginBottom: "10px", flexGrow: 1 }}>
                          <Typography
                            variant="subtitle1"
                            fontWeight={"normal"}
                            color={"#4F46E5"}
                          >
                            {item.descricao}
                          </Typography>

                          {isExpanded && (
                            <Box sx={{ paddingTop: "5px" }}>
                              <Typography variant="body2" color="text.secondary">
                                {item.dataHora} por {item.responsavel}
                              </Typography>
                              <Typography variant="body2" color="text.secondary">
                                {item.texto}
                              </Typography>
                            </Box>
                          )}
                        </Box>
                      </Box>
                    );
                  })}
                </Box>
      )}

        </DivForm>

      </FormProvider>
      <StyledDialog open={open} onClose={handleClose} style={{borderRadius:'15px',background:'transparent'}}>
        <DialogTitle>{modalType.charAt(0).toUpperCase() + modalType.slice(1)} compromisso</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {getDialogText()}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
        <StyledCancelButton onClick={handleClose}>Cancelar</StyledCancelButton>
        <StyledConfirmButton onClick={handleConfirm}>Sim, {modalType}</StyledConfirmButton>
        </DialogActions>
      </StyledDialog>

    </>
  );
}
